import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/A_Draft_Mngt_Report_2May2024_FIN.pdf';

export default function A() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>A Management Report</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
